__webpack_require__.p = "/s2bi/";